/**
 * Theme Requirements Aggregation for Quinn Residences
 * 
 * Extends the base quinn-residences theme requirements with Quinn Residences specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-quinn-residences/requirements';

/**
 * Quinn Residences component requirement overrides.
 * Add requirements for any override components here.
 */
const quinnresidencesOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Quinn Residences theme.
 * Inherits from quinn-residences theme and overrides with Quinn Residences components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...quinnresidencesOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
